export default [
  {
    path: '',
    name: 'main',
    redirect: '/search',
    component: () => import('@views/main'),
    children: [
      {
        path: 'home',
        name: 'home',
        meta: {
          title: '首页',
        },
        component: () => import('@views/home')
      },
      {
        path: 'collection',
        name: 'collection',
        meta: {
          title: '档案征集',
        },
        component: () => import('@views/collection')
      },
      {
        path: 'content',
        name: 'content',
        meta: {
          title: '内容',
        },
        component: () => import('@views/content')
      },
      {
        path: 'notice',
        name: 'notice',
        meta: {
          title: '征集公告',
        },
        component: () => import('@views/notice')
      },
      {
        path: 'search',
        name: 'search',
        meta: {
          title: '预约查档登记',
          otherTitle: '查档资料修改'
        },
        component: () => import('@views/search')
      }, {
        path: 'modify',
        name: 'modify',
        meta: {
          title: '查档资料修改',
          otherTitle: '预约查档登记'
        },
        component: () => import('@views/modify')
      }
    ]
  }
]